import React, { useState, useEffect } from "react";
import {
    Box,
    Card,
    CardHeader,
    CardContent,
    Grid,
    TextField,
    CircularProgress,
    Container,
    useMediaQuery,
    CardMedia,
    SpeedDial,
    SpeedDialIcon,
    SpeedDialAction,
    Snackbar,
    Alert,
    Typography,
} from "@mui/material";
import { getAuth } from "firebase/auth";
import { db } from "../../firebase";
import { getDoc, doc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import EditIcon from "@mui/icons-material/Edit";

function CharacterDetail() {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const [user, setUser] = useState("");
    const [param, setParam] = useState("");
    const [data, setData] = useState([]);

    const isSP = useMediaQuery("(max-width: 600px)");
    const charaPic = isSP ? "300px" : "400px";
    const skillWidth = isSP ? "292px" : "336px";
    const skillPwidth = isSP ? "138px" : "105px";

    const [skillSet, setSkillSet] = useState([
        { val: 15, name: "威圧" },
        { val: 5, name: "言いくるめ" },
        { val: 1, name: "医学" },
        { val: 20, name: "運転" },
        { val: 30, name: "応急手当" },
        { val: 5, name: "オカルト" },
        { val: 15, name: "斧" },
        { val: 20, name: "隠密" },
        { val: 10, name: "火炎放射器" },
        { val: 1, name: "科学" },
        { val: 1, name: "鍵開け" },
        { val: 25, name: "格闘" },
        { val: 5, name: "鑑定" },
        { val: 10, name: "機械修理" },
        { val: 20, name: "聞き耳" },
        {
            val: 0,
            name: "クトゥルフ神話",
        },
        { val: 5, name: "芸術" },
        { val: 5, name: "経理" },
        { val: 20, name: "拳銃" },
        { val: 1, name: "考古学" },
        { val: 15, name: "絞殺ひも" },
        { val: 5, name: "コンピュータ" },
        { val: 10, name: "サバイバル" },
        {
            val: 15,
            name: "サブマシンガン",
        },
        { val: 10, name: "自然" },
        { val: 10, name: "重火器" },
        { val: 1, name: "重機械操作" },
        { val: 5, name: "乗馬" },
        { val: 10, name: "心理学" },
        { val: 1, name: "人類学" },
        { val: 20, name: "水泳" },
        { val: 5, name: "制作" },
        { val: 1, name: "精神分析" },
        { val: 10, name: "説得" },
        { val: 1, name: "操縦" },
        { val: 1, name: "ダイビング" },
        { val: 1, name: "他言語" },
        { val: 10, name: "チェーンソー" },
        { val: 20, name: "跳躍" },
        { val: 10, name: "追跡" },
        { val: 10, name: "手さばき" },
        { val: 10, name: "電気修理" },
        { val: 1, name: "電子工学" },
        { val: 1, name: "伝承" },
        { val: 20, name: "刀剣" },
        { val: 20, name: "登攀" },
        { val: 5, name: "動物使い" },
        { val: 1, name: "読唇術" },
        { val: 20, name: "図書館" },
        { val: 10, name: "ナビゲート" },
        { val: 1, name: "爆破" },
        { val: 1, name: "ヒプノーシス" },
        { val: 10, name: "フレイル" },
        { val: 5, name: "変装" },
        { val: 1, name: "砲" },
        { val: 5, name: "法律" },
        { val: 10, name: "マシンガン" },
        { val: 15, name: "魅惑" },
        { val: 5, name: "むち" },
        { val: 25, name: "目星" },
        { val: 20, name: "槍" },
        { val: 15, name: "弓" },
        { val: 25, name: "ライフル" },
        { val: 5, name: "歴史" },
    ]);

    let convertSkills = "";
    for (const skill of skillSet) {
        convertSkills += "1d100<=" + skill.val + " 【" + skill.name + "】\n";
    }

    const characterData = {
        kind: "character",
        data: {
            params: [
                { label: "STR", value: String(data.str) },
                { label: "CON", value: String(data.con) },
                { label: "POW", value: String(data.pow) },
                { label: "DEX", value: String(data.dex) },
                { label: "APP", value: String(data.app) },
                { label: "SIZE", value: String(data.size) },
                { label: "INT", value: String(data.int) },
                { label: "EDU", value: String(data.edu) },
                { label: "回避", value: String(data.avoid) },
                { label: "DB", value: String(data.db) },
                { label: "ビルド", value: String(data.build) },
                { label: "MOVE", value: String(data.move) },
            ],
            status: [
                { label: "HP", value: data.hp, max: data.hp },
                { label: "MP", value: data.mp, max: data.mp },
                { label: "SAN", value: data.san, max: data.san },
                { label: "LUCK", value: data.lucky, max: data.lucky },
            ],
            name: data.name,
            initiative: data.dex,
            memo:
                "読み：" +
                data.furi +
                "\n年齢：" +
                data.age +
                "歳\n性別：" +
                data.gender +
                "\n職業：" +
                data.job +
                "\n持ち物\n" +
                data.property +
                "\n\nメモ\n" +
                data.memo,
            externalUrl: "",
            commands: convertSkills,
        },
    };

    const fabs = {
        position: "fixed",
        bottom: "1rem",
        right: "1rem",
    };

    const actions = [
        { icon: <EditIcon />, name: "Edit", named: "Trans Edit Page." },
        {
            icon: <ContentCopyIcon />,
            name: "Copy",
            named: "Copied in CCFOLIA format.",
        },
    ];

    const [open, setOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");

    const handleCopy = () => {
        const chara = JSON.stringify(characterData, null, 2);
        global.navigator.clipboard.writeText(chara);

        setSnackbarMessage(actions[0].named);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleEdit = () => {
        window.scrollTo(0, 0);
        navigate(`/character/${param}/edit`);
    };

    const fetchData = async (uid) => {
        const params = window.location.pathname.split("/")[2];
        setParam(params);

        const charaRef = doc(db, "character", params);
        const charaSnap = await getDoc(charaRef);

        if (charaSnap.exists()) {
            if (charaSnap.data().deleted === true) {
                window.scrollTo(0, 0);
                navigate(-1, { replace: true });
            } else {
                if (charaSnap.data().auther === uid) {
                    setData(charaSnap.data());
                } else if (charaSnap.data().private === false) {
                    setData(charaSnap.data());
                }
            }
        }

        const skillData = charaSnap.data();
        const updatedSkillSet = [...skillSet];

        // skillという配列が存在するか確認
        if (skillData.skill && Array.isArray(skillData.skill)) {
            // skill配列の各要素について処理
            skillData.skill.forEach((sk) => {
                if (sk.skill && sk.pSum) {
                    // skillSetの中からnameが一致するものを探す
                    const skillFit = updatedSkillSet.find((item) => item.name === sk.skill);

                    // 一致するものが見つかった場合、valの値をpSumで上書き
                    if (skillFit) {
                        skillFit.val = sk.pSum;
                    }
                }
            });
        }
        setSkillSet(updatedSkillSet);

        setLoading(false);
    };

    useEffect(() => {
        const unsubscribe = getAuth().onAuthStateChanged(async (userLogin) => {
            if (userLogin) {
                setUser(userLogin.uid);
                await fetchData(userLogin.uid);
            } else {
                window.scrollTo(0, 0);
                navigate("/login", { replace: true });
            }
        });
        return () => unsubscribe();
    }, []);

    if (loading) {
        return (
            <Box
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "80vh",
                }}
            >
                <CircularProgress />
            </Box>
        );
    }

    return (
        <div>
            <Helmet>
                <title>Character Detail - SOG Member Site</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>

            <Container maxWidth="1280" sx={{ display: { xs: { maxWidth: 0 } }, maxWidth: 1280 }}>
                <Card sx={{ mt: 10, mb: 2 }}>
                    <CardHeader title={<Typography variant="h6">基本情報</Typography>} />
                    <CardContent>
                        <Grid container alignItems="top">
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <Box
                                    sx={{
                                        width: charaPic,
                                        height: charaPic,
                                        borderRadius: 1,
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        position: "relative",
                                    }}
                                >
                                    <Card>
                                        <CardMedia
                                            component="img"
                                            image={data.img}
                                            style={{ position: "relative" }}
                                            sx={{
                                                objectFit: "contain",
                                                width: charaPic,
                                                height: charaPic,
                                            }}
                                        />
                                    </Card>
                                    {data.dead && (
                                        <Box
                                            sx={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                right: 0,
                                                bottom: 0,
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                transform: "rotate(-45deg)",
                                                opacity: 0.7,
                                            }}
                                        >
                                            <Typography color="black" fontWeight="bold" sx={{ fontSize: 145 }}>
                                                死亡
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <TextField
                                    variant="standard"
                                    readOnly
                                    label="名前"
                                    fullWidth
                                    sx={{ my: 1 }}
                                    value={data.name}
                                    inputProps={{
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="standard"
                                    readOnly
                                    label="フリガナ"
                                    fullWidth
                                    sx={{ my: 1 }}
                                    value={data.furi}
                                    inputProps={{
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="standard"
                                    readOnly
                                    label="性別"
                                    fullWidth
                                    sx={{ my: 1 }}
                                    value={data.gender}
                                    inputProps={{
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="standard"
                                    readOnly
                                    label="年齢"
                                    fullWidth
                                    sx={{ my: 1 }}
                                    value={data.age}
                                    inputProps={{
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="standard"
                                    readOnly
                                    label="職業"
                                    fullWidth
                                    sx={{ my: 1 }}
                                    value={data.job}
                                    inputProps={{
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="standard"
                                    readOnly
                                    label="参考にした作品・キャラ等"
                                    fullWidth
                                    sx={{ my: 1 }}
                                    value={data.reference}
                                    inputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>

                <Card sx={{ my: 2 }}>
                    <CardHeader title={<Typography variant="h6">ステータス</Typography>} />
                    <CardContent>
                        <Grid container alignItems="center">
                            <Grid item xs={12} sm={12} style={{ textAlign: "center" }}>
                                <TextField
                                    variant="standard"
                                    label="HP"
                                    value={data.hp}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="standard"
                                    readOnly
                                    label="MP"
                                    value={data.mp}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="standard"
                                    readOnly
                                    label="SAN"
                                    value={data.san}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="standard"
                                    readOnly
                                    label="幸運"
                                    value={data.lucky}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        inputMode: "numeric",
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="standard"
                                    readOnly
                                    label="回避"
                                    value={data.avoid}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="standard"
                                    readOnly
                                    label="DB"
                                    value={data.db}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="standard"
                                    readOnly
                                    label="ビルド"
                                    value={data.build}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="standard"
                                    readOnly
                                    label="MOVE"
                                    value={data.move}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} sx={{ my: 2 }} style={{ textAlign: "center" }}>
                                <TextField
                                    variant="standard"
                                    readOnly
                                    label="STR"
                                    value={data.str}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="standard"
                                    readOnly
                                    label="CON"
                                    value={data.con}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="standard"
                                    readOnly
                                    label="POW"
                                    value={data.pow}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="standard"
                                    readOnly
                                    label="DEX"
                                    value={data.dex}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="standard"
                                    readOnly
                                    label="APP"
                                    value={data.app}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="standard"
                                    readOnly
                                    label="SIZE"
                                    value={data.size}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="standard"
                                    readOnly
                                    label="INT"
                                    value={data.int}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                                <TextField
                                    variant="standard"
                                    readOnly
                                    label="EDU"
                                    value={data.edu}
                                    sx={{ m: 1, width: "133px" }}
                                    inputProps={{
                                        style: { textAlign: "right" },
                                        readOnly: true,
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>

                <Card sx={{ my: 2 }}>
                    <CardHeader title={<Typography variant="h6">技能</Typography>} />
                    <CardContent>
                        <Grid container sx={{ mt: 5 }} style={{ display: "flex", justifyContent: "center" }}>
                            {data.skill.map((sk, i) => (
                                <Grid item key={i} xs={12} sm={6} sx={{ my: 1 }} style={{ textAlign: "center" }}>
                                    <TextField variant="standard" label="技能" defaultValue={sk.skill} sx={{ mx: 1, width: skillWidth }} />

                                    <TextField
                                        variant="standard"
                                        label="割り振り"
                                        value={sk.point}
                                        sx={{ mx: 1, width: skillPwidth }}
                                        inputProps={{
                                            style: { textAlign: "right" },
                                        }}
                                    />
                                    <TextField
                                        variant="standard"
                                        label="合計"
                                        value={sk.pSum}
                                        sx={{ mx: 1, width: skillPwidth }}
                                        inputProps={{
                                            style: { textAlign: "right" },
                                            readOnly: true,
                                        }}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </CardContent>
                </Card>

                <Card sx={{ mb: 5 }}>
                    <CardHeader title={<Typography variant="h6">その他</Typography>} />
                    <CardContent>
                        <Grid
                            container
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <Grid item xs={12} sm={5.8} sx={{ m: 1 }}>
                                <TextField
                                    variant="outlined"
                                    readOnly
                                    label="持ち物"
                                    multiline
                                    rows={10}
                                    fullWidth
                                    value={data.property}
                                    inputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={5.8} sx={{ m: 1 }}>
                                <TextField
                                    variant="outlined"
                                    readOnly
                                    label="メモ"
                                    multiline
                                    rows={10}
                                    fullWidth
                                    value={data.memo}
                                    inputProps={{
                                        readOnly: true,
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>

                <Box style={fabs}>
                    {user && (
                        <SpeedDial ariaLabel="Action SpeedDial" icon={<SpeedDialIcon />}>
                            {actions.map((action, index) => (
                                <SpeedDialAction
                                    key={index}
                                    icon={action.icon}
                                    tooltipTitle={action.name}
                                    tooltipOpen
                                    onClick={action.name === "Copy" ? handleCopy : handleEdit}
                                />
                            ))}
                        </SpeedDial>
                    )}

                    <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                        <Alert onClose={handleClose} severity="success">
                            {snackbarMessage}
                        </Alert>
                    </Snackbar>
                </Box>
            </Container>
        </div>
    );
}

export default CharacterDetail;
